import tm_routes from 'src/plugins/TM/routes';
// import ki_routes from 'app/oldPlugins/KI/routes';
const plugin_routes = [];
plugin_routes.push(...tm_routes);
// plugin_routes.push(...ki_routes);
export default plugin_routes;
